"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'reserved',
    name: 'Reserved',
    background_color: '#000000',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Roboto-Black.woff',
    heading_text_color: '#ffffff',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Medium.woff',
    heading_2_text_color: '#ffffff',
    body_font: 'https://fonts.raydiant.com/Roboto-Regular.woff',
    body_text_color: '#f6f6f6',
    border_color: '#f6f6f6',
};
//# sourceMappingURL=reserved.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/reserved.js